import { useCallback, useEffect, useMemo, useReducer } from 'react'
import { useMapViewport } from './useMapViewport'
import Supercluster from 'supercluster'

export function useSupercluster(geojson, superclusterOptions) {
  const clusterer = useMemo(() => {
    return new Supercluster(superclusterOptions)
  }, [superclusterOptions])

  const [version, dataWasUpdated] = useReducer((x) => x + 1, 0)

  useEffect(() => {
    clusterer.load(geojson.features)
    dataWasUpdated()
  }, [clusterer, geojson])

  const { bbox, zoom } = useMapViewport({ padding: 100 })

  const clusters = useMemo(() => {
    if (!clusterer || version === 0) return []
    return clusterer.getClusters(bbox, zoom)
  }, [version, clusterer, bbox, zoom])

  const getChildren = useCallback(
    (clusterId) => clusterer.getChildren(clusterId),
    [clusterer]
  )

  const getLeaves = useCallback(
    (clusterId) => clusterer.getLeaves(clusterId, Infinity),
    [clusterer]
  )

  const getClusterExpansionZoom = useCallback(
    (clusterId) => clusterer.getClusterExpansionZoom(clusterId),
    [clusterer]
  )

  return {
    clusters,
    getChildren,
    getLeaves,
    getClusterExpansionZoom
  }
} 